module.exports = __webpack_public_path__ + "img/icons-video-consultation.e02334ef.svg";